import React, { useEffect, useState } from 'react';
import { OPEN_SUGGESTION_EVENT } from '../SuggestionModal';
import Footer from '../Footer';
import SideNav from '../SideNav/SideNav';
import MobileHeader from '../Header/MobileHeader';
import BottomNav from '../BottomNav/BottomNav';
import SuggestionModal from '../SuggestionModal';
import PageTransition from '../PageTransition/PageTransition';
import { useAuth } from '../../contexts/AuthContext';
import { TabType, NavigationDirection } from '../../hooks/useNavigation';
import { useSwipeNavigation } from '../../hooks/useSwipeNavigation';
import { useScrollRestoration } from '../../hooks/useScrollRestoration';
import { submitSuggestion, SuggestionData } from '../../services/suggestionService';
import { TimerProvider } from '../../contexts/TimerContext';
import { PomodoroProvider } from '../../contexts/PomodoroContext';
import { Goal } from '../../services/goalService';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
  activeTab: TabType | null;
  onTabChange: (tab: TabType) => void;
  /** The goal tree, for the sidebar's search and today's count. */
  goals: Goal[];
  navigationDirection: NavigationDirection;
  routeKey: string;
  goBack: () => void;
  /** Drawn over the page, inside the timer providers: the task drawer (T-183). */
  overlay?: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({
  children,
  activeTab,
  onTabChange,
  goals,
  navigationDirection,
  routeKey,
  goBack,
  overlay,
}) => {
  const { state: authState, logout } = useAuth();
  const [isSuggestionOpen, setIsSuggestionOpen] = useState(false);
  // Ayarlar › Yardım › Öneri opens the same form (T-192)
  useEffect(() => {
    const open = () => setIsSuggestionOpen(true);
    window.addEventListener(OPEN_SUGGESTION_EVENT, open);
    return () => window.removeEventListener(OPEN_SUGGESTION_EVENT, open);
  }, []);
  const swipeRef = useSwipeNavigation(goBack);
  useScrollRestoration(routeKey, navigationDirection);

  const handleSuggestionSubmit = async (data: SuggestionData) => {
    await submitSuggestion(data);
  };

  return (
    <TimerProvider>
      <PomodoroProvider>
      <div className="app app-shell">
        {/* Yön B shell (Faz 23, T-180): the sidebar on wide screens; on narrow ones the top
            bar and the four-tab bottom bar. No header bar, no running-timer bar: a running
            timer is the green dot on Zaman. */}
        <div className="desktop-only app-shell__side">
          <SideNav
            activeTab={activeTab}
            onTabChange={onTabChange}
            goals={goals}
            user={authState.user}
            onLogout={logout}
            onOpenSuggestion={() => setIsSuggestionOpen(true)}
          />
        </div>

        <div className="mobile-only">
          <MobileHeader
            user={authState.user}
            onLogout={logout}
            onOpenSuggestion={() => setIsSuggestionOpen(true)}
          />
        </div>

        <div className="app-shell__main">
          <main ref={swipeRef} className="main-content">
            <PageTransition routeKey={routeKey} direction={navigationDirection}>
              {children}
            </PageTransition>
          </main>
          <Footer />
        </div>

        <BottomNav activeTab={activeTab} onTabChange={onTabChange} />

        {overlay}

        {/* Suggestion Modal */}
        <SuggestionModal
          isOpen={isSuggestionOpen}
          onClose={() => setIsSuggestionOpen(false)}
          onSubmit={handleSuggestionSubmit}
        />
      </div>
      </PomodoroProvider>
    </TimerProvider>
  );
};

export default Layout;
